import React from "react";
import { connect, ConnectedProps } from "react-redux";

import Dropdown from "components/Dropdown";
import Constants from "helpers/constants";
import { ProjectType } from "interfaces/project";
import { State } from "state";
import {fetchAllPublishedProjects, fetchMyProjects, fetchMyReportProjects} from "state/my_projects";
import {getItem} from "../helpers/storage";
import {IMPERSONATIONUSER} from "../state/auth";

export interface FilterOptions {
  id: number;
  name: string;
  type: string;
}

interface ProjectFilterOwnProps {
  name?: string;
  defaultOptionLabel?: string;
  exclude?: ProjectType;
  dataQa?: string;
  placeholder?: string;
  onChange: (options: FilterOptions) => any;
  noShadow?: boolean;
  minWidth?: number;
  minHeight?: number;
  value?: number;
  isSearchable?: boolean;
  isDisabled?: boolean;
  isReport?:boolean
  projectId?:number
  loading?: boolean;
}
type ProjectFilterProps = ProjectFilterOwnProps & PropsFromRedux;

interface ProjectFilterState {
  currentId: number;
}

const DROPDOWN_PLACEHOLDER = "Select Project";
const defaultState: ProjectFilterState = { currentId: -999 };
class ProjectFilter extends React.Component<ProjectFilterProps, ProjectFilterState> {
  public state = { ...defaultState};

  public componentDidMount() {
    let { isAdmin,isReport,projectId } = this.props;

    const storedUser = getItem(IMPERSONATIONUSER);
    if (storedUser) {
      const value = JSON.parse(storedUser)
      isAdmin = value && value.role && value.role===Constants.AB_SYSTEM_ADMIN
    }

    return isAdmin ? isReport?this.props.fetchMyReportProjects(projectId): this.props.fetchAllPublishedProjects() :
      isReport?this.props.fetchMyReportProjects(projectId):this.props.fetchMyProjects();
  }

  componentDidUpdate(prevProps: ProjectFilterProps) {
    if (
      this.props.isReport &&
      this.props.projectId &&
      prevProps.projectId !== this.props.projectId
    ) {
      this.props.fetchMyReportProjects(this.props.projectId);
    }
  }

  public render() {
    const {
      projects = [],
      exclude,
      onChange,
      defaultOptionLabel = DROPDOWN_PLACEHOLDER,
      placeholder = DROPDOWN_PLACEHOLDER,
      isSearchable,
      loading,
      ...restProps
    } = this.props;

    const dropdownOptions = [{ value: -1, label: defaultOptionLabel }].concat(
      projects
        .filter((proj) => proj.project_type !== exclude)
        .map((project: any) => {
          const chainProjectName = this.props.isReport ? project.project_name : `${project.chain_name} - ${project.project_name}`;

          return {
            "data-qa": chainProjectName,
            value: project.project_id,
            label: chainProjectName,
            type: project.project_type,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label))
    );

    if (loading && !document.getElementById("pf-spin-style")) {
      const style = document.createElement("style");
      style.id = "pf-spin-style";
      style.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
      document.head.appendChild(style);
    }

    return (
      <div style={{ position: "relative" }}>
        <Dropdown
          {...restProps}
          isDisabled={this.props.isDisabled || loading}
          value={
            loading
              ? null
              : dropdownOptions.find((option) =>
                this.props.value
                  ? option.value === this.props.value
                  : option.value === this.state.currentId
              ) || (defaultOptionLabel ? dropdownOptions[0] : null)
          }
          containerStyles={{
            marginLeft: "unset",
            minWidth: this.props.minWidth ? this.props.minWidth : 230,
            boxShadow: "noShadow",
            noShadow:true,
          }}
          controlStyles={{
            minHeight: this.props.minHeight ? this.props.minHeight : 35,
            borderRadius: "16px",
            boxShadow: "noShadow",
            noShadow:true,
          }}
          options={dropdownOptions}
          onChange={(selected: any) => {
            if (this.props.isDisabled || loading) return;
            this.setState({ currentId: selected.value }, () => {
              if (onChange) {
                onChange({ 
                  id: this.state.currentId,
                  name: selected.label,
                  type: selected.type,
                });
              }
            });
          }}
          placeholder={placeholder}
          isSearchable={!this.props.isDisabled && !loading && isSearchable}
          noShadow={true}
        />

        {/* Overlay shown only while loading */}
        {loading && (
          <div style={{
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            display: "flex",
            alignItems: "center",
            paddingLeft: 12,
            gap: 6,
            borderRadius: 16,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            pointerEvents: "none",
            zIndex: 1,
          }}>
            <svg
              width="14" height="14"
              viewBox="0 0 24 24"
              style={{ animation: "spin 0.8s linear infinite", flexShrink: 0 }}
            >
              <circle cx="12" cy="12" r="10" stroke="#eee" strokeWidth="3" fill="none" />
              <path d="M12 2a10 10 0 0 1 10 10" stroke="#E5B611" strokeWidth="3" fill="none" strokeLinecap="round" />
            </svg>
            <span style={{ fontSize: 13, color: "#999" }}>Fetching Projects...</span>
          </div>
        )}
      </div>
    )
  }
}

const connecter = connect(
  (state: State) => ({
    isAdmin:
      state.auth_user.content &&
      state.auth_user.content.role &&
      state.auth_user.content.role === Constants.AB_SYSTEM_ADMIN,
    projects: state.my_projects.content,
    loading: state.my_projects.loading,
  }),
  { fetchMyProjects, fetchAllPublishedProjects, fetchMyReportProjects }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(ProjectFilter);
